// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__41G5w","header":"ReportDetails_header__2UdV9","title":"ReportDetails_title__30EqF","left":"ReportDetails_left__3QCYb"};